import { IUser } from './interfaces';

export const initState: IUser = {
  logOut: false
};
